/* eslint-disable import/no-anonymous-default-export */
export default {
  gs3t_first_title: '青萍温湿度计 T',
  goose3t: '青萍温湿度计 T',
  gs3t_first_desc_2: '支持 Matter',
  gs3t_banner_title: '青萍温湿度计 T',
  gs3t_banner_desc: '冷暖干湿 一览分明',
  gs3t_matter_title: '支持 Matter{sup}',
  gs3t_matter_desc: '可接入 Apple Home、Google Home、Amazon Alexa、{br}Samsung SmartThings 等支持 Matter 的智能家居平台。',
  gs3t_matter_desc1: '通过 Siri 语音查询温湿度，随时了解室内环境。',
  gs3t_matter_desc2: '通过 Alexa 创建智能联动，如温度升高时自动打开空调{sup}。',
  gs3t_ten_list1: '需配备 Matter 中枢设备和 Thread 边界路由器(或集成了 Thread 的 Matter 中枢设备，例如新款 HomePod 或 Apple TV、Google Nest Hub、Amazon Echo 等)。',
  gs3t_ten_list2: '需在 Alexa app 中设置联动，并搭配兼容的智能空调。',
  gs3t_ten_list3: '实际续航时间可能依环境和电池的差异而有所不同。',
  gs3t_name: '青萍温湿度计 T',
  gs3t_model: 'CGG3T',
  gs3t_ble: 'Thread、蓝牙',
  gs3t_param_platform: '可接入 Apple Home、Google Home、Amazon Alexa、Samsung SmartThings 等支持 Matter 的智能家居平台。',
  gs3t_support_matter: '支持 Matter',
}
